<script setup lang="ts">
import { defineAsyncComponent } from '#imports'

const DynamicTermsComponents = {
    'bonus': defineAsyncComponent(() => import('./DynamicTerms/bonus.vue')),
    'bingo-ticket': defineAsyncComponent(() => import('./DynamicTerms/bingo-ticket.vue')),
    'free-spin': defineAsyncComponent(() => import('./DynamicTerms/free-spin.vue')),
    'scratch-card': defineAsyncComponent(() => import('./DynamicTerms/scratch-card.vue')),
    'wheel-of-fortune': defineAsyncComponent(() => import('./DynamicTerms/wheel-of-fortune.vue')),
}
</script>

<template>
    <PromotionTermsDialog :dynamic-terms-components="DynamicTermsComponents" />
</template>
